import React from 'react';

/**
 * 浮动装饰形状 — 用于登录/注册页面的背景
 */
export const FloatingShapes: React.FC<{ backgroundImage?: string }> = ({ 
  backgroundImage = '/index.jpg'
}) => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {/* 背景图片 */}
    <div 
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    /> 
    
    {/* 半透明遮罩 + 模糊效果 */}
    <div className="absolute inset-0 bg-black/60 backdrop-blur-[3px]" />
    
    {/* 橙色浮动装饰形状 */}
    <div
      className="absolute w-20 h-20 bg-white rounded-full opacity-20 animate-float-slow"
      style={{ top: '10%', left: '10%' }}
    />
    <div
      className="absolute w-16 h-16 bg-white rounded-lg opacity-20 rotate-45 animate-float-medium"
      style={{ top: '20%', right: '15%' }}
    />
    <div
      className="absolute w-12 h-12 bg-white rounded-full opacity-15 animate-float-fast"
      style={{ bottom: '30%', left: '20%' }}
    />
    <div
      className="absolute w-24 h-24 bg-white rounded-lg opacity-20 rotate-12 animate-float-slow"
      style={{ bottom: '20%', right: '10%' }}
    />
    <div
      className="absolute w-10 h-10 bg-white rounded-full opacity-10 animate-float-medium"
      style={{ top: '50%', left: '5%' }}
    />
    <div
      className="absolute w-14 h-14 bg-white rounded-lg opacity-10 rotate-45 animate-float-fast"
      style={{ top: '60%', right: '8%' }}
    />
  </div>
);
